import { myGet, myPost, handleGetError, handlePostError } from '../utils/myAxios'
import { servAddr } from '../servAddr'
import { store } from '../index'

export function fetchRights() {
  const state = store.getState();
  const model = state.auth.rights.right_s_get === 1 ? 'right_s' : 'right';
  return dispatch => {
    myGet(dispatch, servAddr + model).then((response) => {
      dispatch({type: "FETCH_RIGHTS", payload: response.data.rights});
    }, err => {
      handleGetError(dispatch, err);
    })
  }
}

export function editRight(data, cb = () => {}) {
  const state = store.getState();
  const model = state.auth.rights.right_s_post === 1 ? 'right_s' : 'right';
  return dispatch => {
    myPost(dispatch, servAddr + model, {data}).then((response) => {
      cb();
      dispatch({type: "EDIT_RIGHT", payload: data});
    }, err => {
      handlePostError(dispatch, err, cb);
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/rightActions.js